import React from "react";
import Form from "../Form";

import "./Modal.css";

const Modal = () => {
  return (
    <div className="modal-container">
      <div className="modal-box">
        <Form></Form>
      </div>
    </div>
  );
};

export default Modal;
